import Layout from '../components/layout/Layout';
import SectionLabel from '../components/shared/SectionLabel';
import SEO from '../components/shared/SEO';
import '../styles/disclaimerpage.css';

const sections = [
  {
    id: 'relationship',
    number: '01',
    heading: 'Relationship of Apex DeFi Labs and DeFi Assets LLC',
    body: (
      <>
        <p>
          DeFi Assets LLC is a fully owned subsidiary of Apex DeFi Labs ("Apex").
        </p>
        <p>
          The websites ApexDefiLabs.com, DefiAssets.com, VeepCapital.com, PioneerShift.com, and
          SingleFamilyCF.com (collectively, the "Sites") are affiliated platforms and/or brands owned or
          operated by Apex or its subsidiaries.
        </p>
        <p>
          Apex DeFi Labs is not a registered broker-dealer or investment adviser. All broker-dealer
          services, including the sale of tokenized securities, are offered exclusively through Regiment
          Securities, LLC.
        </p>
      </>
    ),
  },
  {
    id: 'partnership',
    number: '02',
    heading: "Apex DeFi Labs' Partnership with Regiment Securities, LLC",
    body: (
      <p>
        Apex DeFi Labs is not a registered broker-dealer or investment adviser. All broker-dealer services,
        including the sale of securities that may be additionally represented by tokens, are offered and
        conducted exclusively through Regiment Securities, LLC, a FINRA-registered broker-dealer and member
        of SIPC. Apex has entered into a strategic partnership with Regiment to make certain securities
        offerings available to accredited and qualified investors. Apex's role is limited to developing and
        operating blockchain or other technology-based solutions that may facilitate investments, including
        providing Issuer-approved tokens that represent securities, but Apex does not solicit, recommend, or
        effect the sale or purchase of any securities.
      </p>
    ),
  },
  {
    id: 'no-advice',
    number: '03',
    heading: 'No Investment, Legal, or Tax Advice',
    body: (
      <p>
        All information provided on Veepcapital.com or any other Apex or DeFi Assets LLC platform,
        including websites, marketing materials, or other communications (collectively, the "Site"), is
        strictly for informational purposes only and should not be construed as investment, legal,
        accounting, or tax advice. Neither Apex nor Regiment provides investment advice to any individual or
        entity, and no communication on or through the Site is intended to be, or should be interpreted as,
        a recommendation or endorsement to buy, sell, or hold any security or other financial product. You
        are solely responsible for conducting any legal, accounting, business, tax, or other due diligence
        review concerning the merits and risks of any potential transaction. Before making any investment or
        other financial decision, you should consult with your own professional advisors.
      </p>
    ),
  },
  {
    id: 'nature-of-offerings',
    number: '04',
    heading: 'Nature of Offerings',
    body: (
      <>
        <p>
          <strong>Private Placements</strong>
        </p>
        <p>
          All information provided on Veepcapital.com or any other Apex or DeFi Assets LLC platform,
          including websites, marketing materials, or other communications (collectively, the "Site"), is
          strictly for informational purposes only and should not be construed as investment, legal,
          accounting, or tax advice. Neither Apex nor Regiment provides investment advice to any individual
          or entity, and no communication on or through the Site is intended to be, or should be interpreted
          as, a recommendation or endorsement to buy, sell, or hold any security or other financial product.
          You are solely responsible for conducting any legal, accounting, business, tax, or other due
          diligence review concerning the merits and risks of any potential transaction. Before making any
          investment or other financial decision, you should consult with your own professional advisors.
        </p>
        <p>
          <strong>High Degree of Risk</strong>
        </p>
        <p>
          Investments in private placements, including tokenized securities, are speculative and involve a
          high degree of risk, including the possible loss of your entire investment. Such investments are
          often illiquid and not suitable for investors who cannot afford to lose their invested capital or
          who need liquidity.
        </p>
        <p>
          <strong>No Assurance of Performance</strong>
        </p>
        <p>
          Any forward-looking statements, financial projections, or target returns referenced on the Site
          are estimates only, provided by the issuer or sponsor of the offering, and no representation or
          warranty is made that any transaction will achieve results or performance similar to those shown.
          Past performance is not indicative of future results.
        </p>
        <p>
          <strong>Issuer Information</strong>
        </p>
        <p>
          All information regarding any specific offering (including but not limited to business plans, risk
          factors, fees, and expenses) is provided solely by the issuer or sponsor of that offering. Apex,
          DeFi Assets LLC, and Regiment do not independently verify or warrant the accuracy or completeness
          of such information.
        </p>
      </>
    ),
  },
  {
    id: 'no-endorsement',
    number: '05',
    heading: 'No Endorsement; Third-Party Links',
    body: (
      <ul>
        <li>
          Apex DeFi Labs, DeFi Assets LLC, and Regiment do not endorse or recommend any particular issuer,
          offering, or investment strategy.
        </li>
        <li>
          Any links to third-party websites or references to third-party content are provided solely for
          convenience. Apex DeFi Assets LLC, and Regiment have no control over such websites or content and
          assume no responsibility for their accuracy or compliance.
        </li>
        <li>
          References to or reproductions of third-party articles or media do not constitute endorsement or
          approval by Apex, DeFi Assets LLC, or Regiment.
        </li>
      </ul>
    ),
  },
  {
    id: 'regulatory',
    number: '06',
    heading: 'Securities Regulatory Disclosures',
    body: (
      <>
        <p>
          <strong>Regulatory Status</strong>
        </p>
        <p>
          Regiment Securities, LLC is a broker-dealer registered with the SEC and a member of FINRA/SIPC.
          You can verify Regiment's status on FINRA's BrokerCheck.
        </p>
        <p>
          <strong>Exempt from Registration</strong>
        </p>
        <p>
          Tokenized securities offered through Regiment may be sold in reliance on exemptions from the
          registration requirements of the Securities Act of 1933, as amended, and other applicable
          securities laws. These securities cannot be offered or sold in the United States absent
          registration or an applicable exemption.
        </p>
        <p>
          <strong>Risk of Total Loss</strong>
        </p>
        <p>
          Neither the SEC nor any federal or state securities commission or regulatory authority has
          recommended or approved any investment offered on the Site, nor has any such authority confirmed
          the accuracy or adequacy of any offering materials. Investors should be prepared to bear the
          entire loss of their investment.
        </p>
        <p>
          <strong>No Guarantee of Compliance</strong>
        </p>
        <p>
          While Regiment is registered with the SEC and is a member of FINRA, such membership and
          registration do not imply that Regiment or any related entity has been endorsed, approved, or
          guaranteed by those regulators. Compliance with all applicable laws, rules, and regulations is an
          ongoing obligation of the firm and its registered representatives.
        </p>
      </>
    ),
  },
  {
    id: 'forward-looking',
    number: '07',
    heading: 'Forward-Looking Statements',
    body: (
      <p>
        Some statements on the Site may contain "forward-looking" information that involves substantial
        risks and uncertainties. Such statements are often identified by terms like "believe,"
        "anticipate," "expect," "estimate," "intend," "project," "will," "may," "should," "could," and
        similar expressions. Any forward-looking statements are based on assumptions that may prove
        incorrect, and no representation is made that such performance will come to pass.
      </p>
    ),
  },
  {
    id: 'uncertainty',
    number: '08',
    heading: 'Uncertainty of Liability',
    body: (
      <p>
        Tokenized securities (and private placements generally) are typically illiquid. There may be no
        active trading markets for these investments, and there is no assurance that a secondary market for
        buying or selling tokenized securities will develop. You should be prepared to hold any investment
        for an extensive period and potentially lose your entire investment.
      </p>
    ),
  },
  {
    id: 'blockchain',
    number: '09',
    heading: 'Use of Technology and Blockchain',
    body: (
      <p>
        Certain offerings may involve the issuance or transfer of securities via blockchain technology. The
        regulatory framework and legal treatment of digital assets and blockchain technologies are evolving
        rapidly, and there can be no assurance as to how laws, regulations, or government policies may
        impact your ability to hold, transfer, or transact in such securities. Potential investors should
        carefully consider these and other technology-specific risks before investing.
      </p>
    ),
  },
  {
    id: 'no-solicitation',
    number: '10',
    heading: 'No Solicitation or Recommendation',
    body: (
      <p>
        No communication by Apex, DeFi Assets LLC, Regiment, or any of their affiliates through the Site
        or any other medium is intended as, or should be construed as, a solicitation of an offer to buy or
        sell, nor a recommendation to purchase, sell, or hold any security or tokenized security.
      </p>
    ),
  },
  {
    id: 'investor-responsibilities',
    number: '11',
    heading: 'Investor Responsibilities',
    body: (
      <>
        <p>Before deciding to invest, you should:</p>
        <ul>
          <li>
            <strong>Conduct Your Own Investigation</strong> — Carefully review all offering materials and
            risk disclosures.
          </li>
          <li>
            <strong>Consider Your Objectives and Circumstances</strong> — Evaluate whether the investment
            aligns with your financial situation, risk tolerance, and investment objectives.
          </li>
          <li>
            <strong>Consult Advisers</strong> — Seek appropriate advice from your own legal, tax,
            financial, and investment professionals.
          </li>
        </ul>
      </>
    ),
  },
  {
    id: 'no-warranties',
    number: '12',
    heading: 'No Warranties or Liability',
    body: (
      <p>
        Neither Apex DeFi Labs Inc, DeFi Assets LLC, Regiment Securities LLC, nor any of their respective
        officers, directors, employees, or affiliates, makes any express or implied representation or
        warranty as to: (i) the accuracy, completeness, or adequacy of any information contained on the
        Site; (ii) the circumstances would Apex DeFi Labs Inc, DeFi Assets LLC, Regiment or their
        affiliates be liable for any direct, indirect, incidental, consequential or other damages arising
        out of your use of or reliance on the information provided.
      </p>
    ),
  },
  {
    id: 'governing-terms',
    number: '13',
    heading: 'Governing Terms',
    body: (
      <p>
        Your access to and use of the Site is subject to our Terms of Service and Privacy Policy. By
        accessing the Site and any pages thereof, you agree to be bound by these terms and policies. If you
        do not agree with the Terms, you should not access the Site or any information or materials
        contained therein.
      </p>
    ),
  },
];

const tocLinks = [
  { label: 'Relationship — Apex & DeFi Assets LLC', id: 'relationship' },
  { label: 'Partnership with Regiment Securities', id: 'partnership' },
  { label: 'No Investment, Legal, or Tax Advice', id: 'no-advice' },
  { label: 'Nature of Offerings', id: 'nature-of-offerings' },
  { label: 'No Endorsement; Third-Party Links', id: 'no-endorsement' },
  { label: 'Securities Regulatory Disclosures', id: 'regulatory' },
  { label: 'Forward-Looking Statements', id: 'forward-looking' },
  { label: 'Uncertainty of Liability', id: 'uncertainty' },
  { label: 'Use of Technology and Blockchain', id: 'blockchain' },
  { label: 'No Solicitation or Recommendation', id: 'no-solicitation' },
  { label: 'Investor Responsibilities', id: 'investor-responsibilities' },
  { label: 'No Warranties or Liability', id: 'no-warranties' },
  { label: 'Governing Terms', id: 'governing-terms' },
];

export default function DisclaimerPage() {
  return (
    <Layout>
      <SEO
        title="Disclaimer - Apex DeFi Labs"
        description="Read the Apex DeFi Labs disclaimer covering investment risks, regulatory disclosures, and the nature of offerings on apexdefilabs.com."
        url="https://apexdefilabs.com/disclaimer"
        type="website"
        keywords="Apex DeFi Labs disclaimer, investment risk, regulatory disclosure, tokenized securities"
      />

      <div className="disclaimer-page">
        {/* Hero */}
        <section className="disclaimer-hero">
          <div className="disclaimer-hero-overlay" />
          <div className="disclaimer-shell">
            <div style={{ marginBottom: '1.2rem' }}>
              <SectionLabel>Legal</SectionLabel>
            </div>
            <h1 className="disclaimer-hero-title">
              <em>Disclaimer</em>
            </h1>
          </div>
        </section>

        {/* Content */}
        <section className="disclaimer-content">
          <div className="disclaimer-shell">
            {/* Table of Contents */}
            <nav className="disclaimer-toc" aria-label="Table of contents">
              <div className="disclaimer-toc-title">Contents</div>
              <ol className="disclaimer-toc-list">
                {tocLinks.map((item) => (
                  <li key={item.id}>
                    <a href={`#${item.id}`}>{item.label}</a>
                  </li>
                ))}
              </ol>
            </nav>

            {/* Sections */}
            {sections.map((section) => (
              <article key={section.id} id={section.id} className="disclaimer-section">
                <span className="disclaimer-section-number">{section.number}</span>
                <h2 className="disclaimer-section-heading">{section.heading}</h2>
                <div className="disclaimer-section-body">{section.body}</div>
              </article>
            ))}
          </div>
        </section>
      </div>
    </Layout>
  );
}
